import React from 'react';
import { arrayOf, string } from 'prop-types';
import { fieldNames } from '../const';
import QuestionText from '../reusable/QuestionText';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';

const EssentialNeedsQuestion = ({ essentialNeedsPurposes, selectedValue }) => {
  const purposes = essentialNeedsPurposes.join(', ');
  const shouldShowTextInput = selectedValue === 'OTHER';
  const essentialNeedOptions = [
    {
      title: 'followup.question.essentialNeeds.yes',
      translationValues: { purposes },
      value: 'GENERAL_TROUBLE',
    },
    {
      title: 'followup.question.essentialNeeds.no',
      value: 'ANOTHER_EXPENSE',
    },
    {
      title: 'followup.question.essentialNeeds.other',
      value: 'OTHER',
    },
  ];

  return (
    <div className="followup__question-container">
      <QuestionText
        textId="followup.question.essentialNeeds"
        values={{ purposes }}
      />
      <RadioBoxesWithInput
        fieldName={fieldNames.essentialNeeds}
        options={essentialNeedOptions}
        shouldShowTextInput={shouldShowTextInput}
        textInputName={fieldNames.essentialNeedsClarification}
        textInputTitleId="followup.question.essentialNeeds.clarification"
      />
    </div>
  );
};

EssentialNeedsQuestion.propTypes = {
  essentialNeedsPurposes: arrayOf(string),
  selectedValue: string,
};

export default EssentialNeedsQuestion;
